import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as Sentry from '@sentry/browser'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import App from './App'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({ dsn: 'https://e1e7aab9caaf481aa9bad859a9742f1e@appmon.catalyst.net.nz/68' })
}

// Start the mocking conditionally.
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { worker } = require('./mocks/browser')
  worker.start()
  console.log('MSW Worker started!')
}

const div = document.createElement('div')
div.id = 'app'
document.body.appendChild(div)

ReactDOM.render(React.createElement(App), div)
